var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10V35.1495C5 35.2786 5.10471 35.3833 5.23387 35.3833C5.36303 35.3833 5.46774 35.2786 5.46774 35.1495V33.4578C5.46774 32.3944 6.32983 31.5323 7.39328 31.5323H27C30.866 31.5323 34 28.3983 34 24.5323V10C34 6.13401 30.866 3 27 3H12C8.13401 3 5 6.134 5 10Z",
    stroke: "#8A96A3",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8867 14.2256H25.1125",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8867 19.8389H20.4351",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.546f00bcebac9730c85ed92a48a13a86.svg";
export { ForwardRef as ReactComponent };